export function isValidAlphabetical(stringValue) {
  return stringValue && !/[<>?\\\/*+!@$#%^&*()=}{\]\[|\\|~:;,._"'0-9]/.test(stringValue);
}

export function containsOnlySpaces(value: string) {
  return value && /^\s*$/.test(value);
}

export function isValidName(stringValue) {
  return stringValue && /^[a-zA-Z- öç-]+$/.test(stringValue);
}

export function isValidNumbers(numbers) {
  return !!numbers && numbers.length > 0 && /^\d+$/.test(numbers);
}

export function hasNoSpecialCharacters(stringValue) {
  return stringValue && !/[<>?\\\/*+!@$#%^&*()=}{\]\[|\\|~:;,_"']/.test(stringValue);
}

export function isValidEmail(email) {
  return (
    email &&
    email.length >= 6 &&
    /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]{1,64}@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/.test(email)
  );
}

export function IsValidLulalendPassport(idString) {
  return !!idString && idString.length >= 6 && idString.length <= 13;
}

export function isValidEmailTradeRoot(email) {
  return !validateEmailTradeRoot(email);
}

export function validateEmailTradeRoot(email) {
  let error;

  if (!isEmailTradeRootCompliantDoublePunctuationFree(email)) {
    error = 'Double Punctuation Error';
  } else if (!isEmailTradeRootCompliantBelowMaximumLength(email)) {
    error = 'Address Is Above Maximum Length Requirement';
  } else if (!isEmailTradeRootCompliantAboveMinimumLength(email)) {
    error = 'Address Is Below Minimum Length Requirement';
  } else if (!isEmailTradeRootCompliantHasAtSign(email)) {
    error = 'No @ Sign';
  } else if (!isEmailTradeRootCompliantDoesNotHaveMultipleAtSigns(email)) {
    error = 'Multiple @ Signs';
  }

  return error ? `Invalid Email Address: ${error}` : null;
}

export function isEmailTradeRootCompliantDoublePunctuationFree(email) {
  return !/([^a-zA-Z\d\s:]{2,})/.test(email);
}

export function isEmailTradeRootCompliantBelowMaximumLength(email) {
  return email.length <= 100;
}

export function isEmailTradeRootCompliantAboveMinimumLength(email) {
  return email.length >= 6;
}

export function isEmailTradeRootCompliantHasAtSign(email) {
  return email.includes('@');
}

export function isEmailTradeRootCompliantDoesNotHaveMultipleAtSigns(email) {
  return email.match(/@/g).length <= 1;
}

export function validateBankAccountHolderNameTradeRoot(bankAccountHolderName) {
  let error;

  if (!bankAccountHolderName || bankAccountHolderName.length > 30) {
    error = 'Name is above maximum length requirement';
  }

  if (!bankAccountHolderName || bankAccountHolderName.length < 5) {
    error = 'Bank Account Holder Name too short. Minimum length of 5 required';
  }

  return error ? `Invalid Account Holder Name: ${error}` : null;
}

export function validateBusinessNameTradeRoot(bankAccountHolderName) {
  let error;

  if (!bankAccountHolderName || bankAccountHolderName.length > 30) {
    error = 'Business Name is above maximum length requirement';
  }

  if (!bankAccountHolderName || bankAccountHolderName.length < 5) {
    error = 'Business Name too short. Minimum length of 5 required';
  }

  return error ? `Invalid Business Name: ${error}` : null;
}

export function isValidMobileNumber(mobileNumber) {
  return mobileNumber && /^\+27[1-8]\d{8}?$/.test(mobileNumber);
}

export function isValidRegistrationNumber(registrationNumber) {
  return !!registrationNumber && /^\d{4}\/\d{6}\/\d{2}$/.test(registrationNumber);
}

export function isValidRegistrationNumberTrust(registrationNumber) {
  return !!registrationNumber && /^IT\d{6}\/\d{4}$/.test(registrationNumber);
}

export function isValidID(ID) {
  let valid =
    ID &&
    /^(((\d{2}((0[13578]|1[02])(0[1-9]|[12]\d|3[01])|(0[13456789]|1[012])(0[1-9]|[12]\d|30)|02(0[1-9]|1\d|2[0-8])))|([02468][048]|[13579][26])0229))(( |-)(\d{4})( |-)(\d{3})|(\d{7}))$/.test(
      ID,
    );
  return valid ? idCheckSum(ID) : false;
}

function idCheckSum(idString) {
  let control = -1;
  try {
    let a = 0;
    for (let i = 0; i < 6; i++) {
      a += parseInt(idString[2 * i]);
    }

    let b = 0;
    for (let i = 0; i < 6; i++) {
      b = b * 10 + parseInt(idString[2 * i + 1]);
    }
    b *= 2;
    let bAsString = b.toString();
    let c = 0;
    for (let i = 0; i < bAsString.length; i++) {
      c += parseInt(bAsString[i]);
    }
    c += a;
    control = 10 - (c % 10);
    if (control == 10) control = 0;
  } catch {
    /*ignore*/
  }
  return parseInt(idString.slice(-1)) === control;
}

export function isValidBankAccountNumber(bankAccountNumber) {
  return isValidNumbers(bankAccountNumber) && bankAccountNumber.length <= 20;
}

export function isValidBranchCode(branchCode) {
  return isValidNumbers(branchCode) && branchCode.length === 6;
}

export function isValidBranchName(stringValue) {
  return stringValue && /^[a-zA-Z][a-zA-Z\s]+$/.test(stringValue);
}

export function isValidFileName(fileName) {
  return fileName && /^[\w,\s-.]+$/.test(fileName) && fileName.length <= 255;
}

/**
 * @description
 * Used to check if value is a legal url
 * accepts url's that begin with https:// or http://
 * has to have at least one period
 * there must be at least one character ( hyphen, period or alphanumeric ) before the first period
 * there needs to be something ( anything ) after the first period
 * @param value
 * @returns true if url is valid
 * @returns false otherwise
 */
export function isValidUrl(value) {
  const urlRegex = /(http(s)?:\/\/)?[\-\.a-zA-Z0-9]+\..+/g;

  return urlRegex.test(value);
}

/**
 *  Used to check if a value is a number
 *  @param value
 *  @return true if value is number (or string representation of a number).
 *  @return false otherwise
 **/
export function isValidNumber(value) {
  return value !== '' && value !== null && value !== undefined && !isNaN(value);
}

/**
 *  Used to check if two strings are equal(case insensitive)
 *  @param stringA
 *  @param stringB
 *  @return true if stringA and stringB are valid and equal
 *  @return false otherwise
 **/
export const isEqualCaseInsensitive = (stringA, stringB) =>
  !!stringA && !!stringB && stringA.toLowerCase() === stringB.toLowerCase();

export const isURLValid = (str: string) => {
  try {
    const newUrl = new URL(str);
    return newUrl.protocol === 'http:' || newUrl.protocol === 'https:';
  } catch (err) {
    const pattern = /^www\.[\w-]+\.\w{2,}(\.\w{2,})?$/;
    return pattern.test(str);
  }
};
